export const routes = {
  home: "/",
  dashboard: "/dashboard",
  admin: "/",
  passwordForgot: "/passwordForgot",
  resetPassword: "/resetPassword",
  ReporteVacaciones: "/ReporteVacaciones",
  headcount: "/headcount",
  genera_planilla_produccion: "/genera_planilla_produccion",
};
export const time_zone = "00:00:00";
